
function attachAddToCartListener() {
  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-event-name$='add_to_cart']");
    if (button) {
      const eventName = button.dataset.eventName || "custom_add_to_cart";
      gtag("event", eventName, {
        page_section: button.dataset.itemListName,
        currency: Shopify.currency.active,
        custom_item_id: button.dataset.productId,
        custom_item_name: button.dataset.productTitle,
        custom_price: Number(button.dataset.productPrice) / 100,
        custom_item_category: button.dataset.productType,
      });
    }
  });
}

function trackElementInView() {
  const options = {
    root: null, // default viewport
    rootMargin: "0px", // margin offset
    threshold: 0.8, // the callback is invoked when 80% of the target element is visible
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target;

        gtag("event", "element_in_view", {
          page_section: target.dataset.pageSection,
          element_position: target.dataset.elementPosition,
          element_id: target.dataset.elementId,
        });

        observer.unobserve(target);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  const mediaInViewElements = document.querySelectorAll("[data-event-name='element_in_view']");
  mediaInViewElements.forEach((element) => observer.observe(element));
}

function trackElementClick() {
  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-event-name$='custom_click']");
    if (button) {
      const eventName = button.dataset.eventName || "custom_click";
      gtag("event", eventName, {
        page_section: button.dataset.pageSection,
        element_position: button.dataset.elementPosition,
        element_id: button.dataset.elementId,
      });
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", attachAddToCartListener);
  document.addEventListener("DOMContentLoaded", trackElementInView);
  document.addEventListener("DOMContentLoaded", trackElementClick);
} else {
  attachAddToCartListener();
  trackElementInView();
  trackElementClick();
}
